import { api } from "@/lib/api";

const KEY = "jp_player";

export const digitsOnly = (v, max) => v.replace(/\D/g, "").slice(0, max);

export const gameIdError = (v) => (/^\d{1,10}$/.test(v) ? "" : "hanya angka, maksimal 10 digit");

export const waError = (v) => {
  if (!v) return "Nomor WhatsApp wajib diisi";
  if (!v.startsWith("08")) return "Nomor WhatsApp wajib diawali 08";
  if (v.length < 10) return "Nomor WhatsApp minimal 10 digit";
  return "";
};

export const loadPlayer = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || null;
  } catch {
    return null;
  }
};

// Only non-sensitive helpers for form filling: game IDs + WA number
export const savePlayer = (productId, gameId, wa) => {
  const cur = loadPlayer() || { ids: {} };
  localStorage.setItem(KEY, JSON.stringify({ ids: { ...cur.ids, [productId]: gameId }, wa, last_game: productId }));
};

export const clearPlayer = () => localStorage.removeItem(KEY);

export const newRequestId = () =>
  (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);

export const uploadProof = async (kind, file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post(`/uploads/proof?kind=${kind}`, fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data.proof_id;
};

export const GAME_ID_LABEL = { royal_dream: "ID Royal Dream", higgs_domino: "ID Higgs Domino" };
